module.exports = __webpack_public_path__ + "img/icon-05.fecc9a95.png";